module.exports = __webpack_public_path__ + "img/img02.2ce5e0ad.png";